import { isString } from "lodash";
import { storage } from "@unifiedpatents/sso";

export function optionsGen(action = "GET", body, auth, additionalHeaders = {}) {
  let headers = {
    Accept: "application/json",
    ...additionalHeaders,
  };
  if (auth) headers["Authorization"] = "Bearer " + storage.getItem("idToken");
  let options = {
    method: action,
    mode: "cors",
    headers: headers,
  };
  if (body) {
    options.body = isString(body) ? body : JSON.stringify(body);
    options.headers["Content-Type"] = "application/json";
  }
  return options;
}
